import { Component, Input, model, OnChanges, OnInit, inject, output } from '@angular/core';

import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {DatePickerComponent} from "../date-picker/date-picker.component";

export interface DateRange {
	startDate: Date;
	endDate: Date;
}

@Component({
    selector: 'date-range-picker',
    imports: [DatePickerComponent, ReactiveFormsModule],
    templateUrl: './date-range-picker.component.html',
    styleUrl: './date-range-picker.component.scss'
})
export class DateRangePickerComponent implements OnInit, OnChanges{
	private fb = inject(FormBuilder);

	dateRangeForm: FormGroup = new FormGroup({});
	minDate = model<Date>()
	maxDate = model<Date>()
	dateRange = model<DateRange>()
	formReset = model<boolean>()
	readonly dateRangeSelected = output<DateRange>();
	today = new Date();

	ngOnChanges() {
		if (this.formReset()) {
			this.dateRangeForm.reset();
			this.formReset.set(false)
		}
	}

	ngOnInit(){
		this.dateRangeForm = this.fb.group({
			startDate: [this.minDate()],
			endDate: [this.maxDate()],
		});
	}

	setDate(date: Date | undefined, formName: string): void {
		this.dateRangeForm.get(formName)?.patchValue(date)
		this.dateRangeSelected.emit(this.dateRangeForm.value);
	}
}

